import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";
import { Paper, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MyLogoLight from "../../vendor/ME_Light.png";
import SignInComponent from "../../components/auth/SignIn";
import { useDispatch } from "react-redux";
import { setMenuData } from "../../redux/slices/sidebarMenu";

const Brand = styled.img`
  fill: ${(props) => props.theme.palette.primary.main};
  display: block;
  margin: 0 auto;
  width: 180px;
  margin-bottom: ${(props) => props.theme.spacing(3)};

  ${(props) => props.theme.breakpoints.up("sm")} {
    width: 220px;
  }

  ${(props) => props.theme.breakpoints.up("md")} {
    width: 256px;
    margin-bottom: ${(props) => props.theme.spacing(4)};
  }
`;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};
  margin: ${(props) => props.theme.spacing(2)};
  width: calc(100% - ${(props) => props.theme.spacing(4)});

  ${(props) => props.theme.breakpoints.up("sm")} {
    padding: ${(props) => props.theme.spacing(4)};
    margin: ${(props) => props.theme.spacing(3)} auto;
    width: 80%;
    max-width: 600px;
  }

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(6)};
    width: 60%;
  }

  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: ${(props) => props.theme.spacing(8)};
    width: 40%;
  }
`;

function SignIn() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setMenuData([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const isUserLoggedIn = sessionStorage.getItem("token") != null;
    if (isUserLoggedIn) {
      navigate("/private");
    }
  }, [navigate]);

  return (
    <React.Fragment>
      <Wrapper>
        <Brand src={MyLogoLight} alt="My Logo" />
        <Helmet title="Sign In" />
        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Welcome back!
        </Typography>
        <Typography component="h2" variant="body1" align="center">
          Sign in to your account to continue
        </Typography>

        <SignInComponent />
      </Wrapper>
    </React.Fragment>
  );
}

export default SignIn;
